<template>
  <div>
    <div v-if="settings">
      <header>
        <h2>
          Date: {{ today }}
        </h2>
        <h2>
          Invoice
        </h2>
      </header>

      <aside>
        <address>
          Glenn Turner<br />
          1422 W. Rascher Ave. #1A<br />
          Chicago, IL 60640<br />
          (773) 919-3141<br />
          <a href="mailto:contact@iamgturner.com">contact@iamgturner.com</a>
        </address>
      </aside>

      <div>
        <h3>
          Bill to:
        </h3>
        <address>
          {{ businessName }}<br />
        </address>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>
              Description
            </th>
            <th>
              Amount
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              Puzzle Service Subscription ({{ startAt }} to {{ endAt }})
            </td>
            <td>
              ${{ invoiceTotal }}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <th>Total</th>
            <th>${{ invoiceTotal }}</th>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    startAt: {
      type: String,
      default: undefined
    },
    endAt: {
      type: String,
      default: undefined
    },
    invoiceTotal: {
      type: Number,
      default: 0
    }
  },

  computed: mapState({
    today () {
      const d = new Date()
      return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`
    },

    businessName () {
      const setting = this.settings.find(s => s.slug === 'business_name')
      return setting ? setting.val : ''
    },

    base: state => state.base,
    settings: state => state.SettingModule.settings
  }),

  mounted () {
    this.$store.dispatch(
      `SettingModule/getSettings`
    ).catch(this.$root.processErrors)
  }
}

</script>
<style>
@media print {
  header:first-child,
  #header-nav,
  footer:last-child,
  nav {
    display: none !important;
  }

  main > div > h2 {
    border: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseReportsInvoice.vue